import { DocumentExecutionService } from '@services/actions/DocumentExecutionService';
import { AttachmentsArchiveExecutor } from '../parts/AttachmentsArchiveExecutor';

export class DownloadAllExecutor extends AttachmentsArchiveExecutor {
    protected readonly syncRoute = 'downloadAll';

    protected startInBackground(service: DocumentExecutionService, actionKey: string) {
        return service.startDownloadAllInBackground(actionKey);
    }
}
